import { ApproveRequirementData } from "../Component/ApproveRequirement/Data/ApproveRequirement.data";
import { RequirementApprovalData } from "../Data/RequirementApproval.data";

export const setAllDropDownField = (apiResponse) => {
    const filterDropDownList = (dropdownName) => {
        return apiResponse.reduce((acc, item) => {
            if (item.dropdownName === dropdownName) {
                acc.push({
                    value: item.id,
                    label: item.name,
                });
            }
            return acc;
        }, []);
    }

    const dropdownLists = {
        "channel": filterDropDownList("Channel"),
        "requirementSection": filterDropDownList("Requirement Section"),
        "statusId": filterDropDownList("Requirement Section Status"),
    };

    const formFields = [...RequirementApprovalData.formFields,...ApproveRequirementData.formFields];

    formFields.forEach(field => {
        const dropdownList = dropdownLists[field?.id];
        if (dropdownList) {
            field.fieldSetting.options = dropdownList;
        }
    });
};